var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPieChart = function SvgPieChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.924 3.432c.396-.085.75.231.75.636a.724.724 0 0 1-.576.693 7.058 7.058 0 1 0 8.46 8.476.725.725 0 0 1 .693-.575c.406 0 .722.356.637.752a8.394 8.394 0 1 1-9.964-9.982Z",
    fill: "#1E5DFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 2,
    width: 9,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.325 11.132c.984 0 1.799-.804 1.604-1.768a8.903 8.903 0 0 0-6.957-6.957c-.964-.195-1.769.62-1.769 1.603v5.342c0 .983.797 1.78 1.78 1.78h5.342Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.326 11.132c.984 0 1.799-.806 1.604-1.77a8.903 8.903 0 0 0-6.957-6.956c-.964-.195-1.769.62-1.769 1.603v5.342c0 .983.797 1.78 1.78 1.78h5.342Z",
    stroke: "#1E5DFF",
    strokeWidth: 3.339
  }))));
};
export default SvgPieChart;